import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Tab } from 'semantic-ui-react';

import styles from './PreferencesPane.module.scss';

const isTgDebugEnabled = () => {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    const byStorage = window.localStorage?.getItem('debugTG') === '1';
    const byQuery = new URLSearchParams(window.location.search).get('debugTG') === '1';

    return byStorage || byQuery;
  } catch {
    return false;
  }
};

const PreferencesPane = React.memo(({ tgActivateLink, telegramId }) => {
  const [t] = useTranslation();

  const isTelegramConnected = telegramId !== null && telegramId !== undefined && telegramId !== '';
  const debugEnabled = isTgDebugEnabled();

  useEffect(() => {
    if (!debugEnabled) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log('[TG][UserSettings] PreferencesPane props/state=', {
      telegramId,
      isTelegramConnected,
      tgActivateLink,
    });
  }, [debugEnabled, telegramId, isTelegramConnected, tgActivateLink]);

  return (
    <Tab.Pane attached={false} className={styles.wrapper}>
      <div>
        <Button
          fluid
          as={isTelegramConnected ? undefined : 'a'}
          target={isTelegramConnected ? undefined : 'blank_'}
          href={isTelegramConnected ? undefined : tgActivateLink}
          disabled={isTelegramConnected}
          color={isTelegramConnected ? 'blue' : undefined}
          className={`CardModal_actionButton__1eB1l ${
            isTelegramConnected ? styles.tgConnectedButton : ''
          }`}
        >
          <i aria-hidden="true" className="paper plane outline icon CardModal_actionIcon__dnocs" />
          {isTelegramConnected
            ? t('telegram.connected', { defaultValue: 'Notifications successfully connected' })
            : t('telegram.activate_link')}
        </Button>
      </div>
      {debugEnabled && (
        <div style={{ marginTop: 8, fontSize: 12, opacity: 0.75, wordBreak: 'break-word' }}>
          <div>
            <b>[TG DEBUG]</b> telegramId: <code>{String(telegramId)}</code>
          </div>
          <div>
            <b>[TG DEBUG]</b> isTelegramConnected: <code>{String(isTelegramConnected)}</code>
          </div>
          <div>
            <b>[TG DEBUG]</b> tgActivateLink: <code>{String(tgActivateLink)}</code>
          </div>
        </div>
      )}
    </Tab.Pane>
  );
});

PreferencesPane.propTypes = {
  tgActivateLink: PropTypes.string.isRequired,
  telegramId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

PreferencesPane.defaultProps = {
  telegramId: undefined,
};

export default PreferencesPane;
